import { render, staticRenderFns } from "./PlacementTypeChart.vue?vue&type=template&id=4f509480&scoped=true"
import script from "./PlacementTypeChart.vue?vue&type=script&lang=js"
export * from "./PlacementTypeChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f509480",
  null
  
)

export default component.exports